import React, { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { Col, Row, Space } from 'antd'
import { DetailReq } from 'Store/merchants/types'
import { getMerchantsDetailAPI, updateMerchantsAPI } from 'Store/merchants/api'
import { selectActionEvent, selectDetail, selectDetailEvent } from 'Store/merchants/selector'
import { selectCurrentUser } from 'Store/user/selector'
import LoadingView from 'Components/modal/LoadingView'
import HomePageLayout from 'Pages/Layout/PageLayout'
import { InfoItem, MerchantAccount, MerchantDetail, MerchantAddress } from 'Pages/Merchants/components'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { formatDateTime, getConfigByKey, getStatus } from 'helpers/format'
import { useState } from 'react'
import { UpdateReq } from 'Store/merchants/types'
import { cloneDeep } from 'lodash'
import { PrimaryButton } from 'Components/button'
import { EventModal } from 'Components/modal'
import { clearEventAction } from 'Store/merchants/actions'
import { updateActiveMerchantLogoAction } from 'Store/user/actions'
import { DocumentConfigKey, VAT_TYPE } from 'helpers/constanst'
import { selectConfigList } from 'Store/pos/selector'

type Props = {} & ReduxProps

const MerchantProfile: React.FunctionComponent<Props> = props => {
  const { currentUser, detail, detailEvent, event: updateEvent, configList } = props
  const initForm = {} as UpdateReq
  const [formData, setFormData] = useState(cloneDeep(initForm))
  const dispatch = useDispatch()

  const configData = getConfigByKey(configList, DocumentConfigKey.VAT_TYPE)
  const config = (configData && configData?.config_value) || ''
  const vatType =
    config === VAT_TYPE.EX
      ? 'Exclude Vat (ราคาของสินค้าที่ยังไม่ได้รวมภาษีมูลค่าเพิ่ม)'
      : 'Include Vat (ราคาของสินค้าที่รวมภาษีมูลค่าเพิ่มแล้ว)'

  useEffect(() => {
    onGetDetail()
  }, [])

  useEffect(() => {
    if (detail) {
      const form = {
        ...detail,
      } as UpdateReq
      setFormData({ ...form })
    }
  }, [detail])

  const onGetDetail = (): void => {
    const req: DetailReq = {
      id: currentUser?.activeMerchant?.id || 0,
    }
    dispatch(getMerchantsDetailAPI(req, currentUser.accessToken))
  }

  const onUpdate = (): void => {
    const req: UpdateReq = {
      ...formData,
      id: currentUser?.activeMerchant?.id || 0,
    }

    dispatch(updateMerchantsAPI({ data: req }, currentUser.accessToken))
  }

  const onUpdateData = (val: any, key: string) => {
    setFormData({
      ...formData,
      [key]: val,
    })
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onEventSuccess = (): void => {
    clearEvent()
    onGetDetail()
    dispatch(updateActiveMerchantLogoAction({ logo: formData.logo }))
  }

  const merchantName = currentUser?.activeMerchant?.name || ''
  const title = <InfoTitle>วันที่เข้าร่วม : {formatDateTime(detail?.created_at || '')}</InfoTitle>

  const renderMerchantSetting = () => {
    const isMasterProduct = detail?.master_product || false
    return (
      <BoxWrapper>
        <BoxTitle>ตั้งค่าร้านค้า</BoxTitle>
        <Col md={24} xs={24}>
          <InfoItem title={'สินค้าตัวกลาง'} value={getStatus(isMasterProduct)} />
        </Col>
        <Col md={24} xs={24}>
          <InfoItem title={'ภาษีมูลค่าเพิ่มในสินค้า'} value={vatType} />
        </Col>
      </BoxWrapper>
    )
  }

  return (
    <HomePageLayout selected="merchant-profile" title={merchantName} label={title}>
      <LoadingView isShow={detailEvent.IsLoading} />
      <EventModal
        event={[updateEvent]}
        enable={true}
        successCalback={onEventSuccess}
        errorCalback={clearEvent}
      />
      <Row justify="space-between" gutter={16}>
        <Col lg={8} xs={24}>
          <MerchantDetail
            mode={'edit'}
            formData={formData}
            detail={detail}
            readonly={true}
            onUpdateData={onUpdateData}
            token={currentUser?.accessToken}
            showPointSummary={true}
          />
        </Col>
        <Col lg={16} xs={24}>
          <Row gutter={16}>
            <Col md={24} xs={24}>
              <MerchantAddress mode={'edit'} formData={detail} detail={detail} readonly={true} />
            </Col>
            <Col md={24} xs={24}>
              <MerchantAccount detail={detail} />
            </Col>
            <Col md={24} xs={24}>
              {renderMerchantSetting()}
            </Col>
          </Row>
        </Col>
      </Row>
      <Row justify="end" align="middle">
        <Col>
          <Space size="large">
            <PrimaryButton text="ยืนยันแก้ไขข้อมูล" onClick={onUpdate} />
            <PrimaryButton btnType="Cancel" text="ยกเลิก" onClick={onGetDetail} />
          </Space>
        </Col>
      </Row>
    </HomePageLayout>
  )
}

const BoxTitle = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.primary};
`

const BoxWrapper = styled.div`
  width: 100%;
  border-radius: 10px;
  padding: 15px 10px;
  //border: 1px solid ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
  border: 1px solid #f0f0f0;
  margin-bottom: 10px;
  background-color:  ${(props: { theme: MyTheme }): string => props.theme.colors.white};
`

const InfoTitle = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    event: selectActionEvent(state),
    detail: selectDetail(state),
    detailEvent: selectDetailEvent(state),
    configList: selectConfigList(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(MerchantProfile)
